const n = (e, a) => {
  const { success: c, error: s } = e.safeParse(a);
  c || console.warn(s == null ? void 0 : s.issues);
};
export {
  n as safeParse
};
